import React from 'react';
import { injectStripe, CardElement } from 'react-stripe-elements'
import Modal from 'components/UI/Modal';
import addPaymentMethod from 'controllers/payment/addPaymentMethod';
import deletePaymentMethod from 'controllers/payment/deletePaymentMethod';
import changeSubscription from 'controllers/payment/changeSubscription';
import addSubscription from 'controllers/payment/addSubscription';
import { alert } from 'util/alert';
import {SAAS_VERSIONS} from 'data/constants'
import "./PaymentModal.scss";
import moment from 'moment';
import isEmpty from 'lodash/isEmpty';
// This is how you modify the style of CardElement
// You can't do it with plain CSS
const cardElementStyle = {
	base: {
		iconColor: '#D2D2D2',
		fontWeight: 300,
		'::placeholder': {
			fontWeight: 300,
			color: '#D2D2D2',
			fontSize: '12px',
			lineHeight: '13px',
		}
	}
}
const locale = {
  id: 'OrderOverview',
  code: 'CN',
  text: {
    'All payments are processed through Stripe. The connection is secure and encrypted. We do not collect any of your information.':'所有付款都通过 Stripe 处理。付款连接是安全并且加密的。我们不会收集您的任何信息。',
    'Privacy Policy': '隐私政策',
    'Note: 5% tax will be applied on every transaction': '提示: 每次付款会额外收取5%的税金'
  }
}

class CheckoutModal extends React.Component {

  constructor(props){
    super(props)

    this.state = {
      email: '',
			class: 'form-control email-input',
      processingPayment: false,
      selectedTab: 'monthly',
      selectedPlanInfo:{}
    }

    this.onSubmit = this.onSubmit.bind(this)
    this.onChangeEmail = this.onChangeEmail.bind(this)
    this.onTabChange = this.onTabChange.bind(this)
  }
  componentWillMount(){
    this.setState({selectedPlanInfo: this.props.selectedPlanInfo, selectedTab: this.props.selectedPlanInfo.billCycle})
  }
  onChangeEmail(event){
		let validation = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
		if (validation.test(event.target.value)) {
			this.setState({class: 'form-control email-input'})
		} else {
			this.setState({class: 'form-control email-input email-error'})
		}

    this.state.email = event.target.value
    this.setState({email: this.state.email})
  }
  onTabChange(){
    const {selectedTab, selectedPlanInfo} = this.state;
    if(selectedTab === 'monthly'){
      let yearlyPlan = SAAS_VERSIONS.find((version)=>{
        return version.name === selectedPlanInfo.name && version.billCycle==='yearly'
      })
      this.setState({selectedTab: 'yearly', selectedPlanInfo: yearlyPlan})
    }else {
      let monthlyPlan = SAAS_VERSIONS.find((version)=>{
        return version.name === selectedPlanInfo.name && version.billCycle==='monthly'
      })
      this.setState({selectedTab: 'monthly', selectedPlanInfo: monthlyPlan})
    }
  }
  onSubmit(ev){
		const {
      proceed,
      dismiss,
      cancel,
      onSuccess,
      currentPaymentMethod,
      saasVersion
		} = this.props;
    const {selectedPlanInfo} = this.state;
    ev.preventDefault();

    if(!this.state.email) {
		  this.setState({class: 'form-control email-input email-error'})
		  ev.preventDefault();
      return;
    }

    // We could pass customer to createToken()
    // let customer = {}
		this.setState({processingPayment: true})
    this.props.stripe.createToken().then((payload) => {
      addPaymentMethod({
        source: payload.token.id,
        email: this.state.email,
        set_default: 'set_default'
      })
        .then((res)=>{
          if(res.result==='success'){
            if(!isEmpty(currentPaymentMethod)){
              deletePaymentMethod(currentPaymentMethod.id)
              .then((res)=>{
              })
            }
            let subscriptionCtrl = saasVersion === 0? addSubscription : changeSubscription;

            subscriptionCtrl({plan_codename: selectedPlanInfo.planCodename})
              .then((res)=>{
                this.setState({processingPayment: false})
                if(res.result === 'success'){
                  alert.success(__('You are on {planName} now!', 'settings', {planName: __(selectedPlanInfo.name, 'settings')}), __('Congratulations!', 'settings'))
                  .then(() => {
                    proceed()
                  })
                }else {
                  alert.fail(__('Your current account can not be changed to this plan!', 'settings'), __('Failed to change plan!', 'settings'))
                  .then(() => {
                    dismiss()
                  })
                }
              })

          }else{
            return
          }
        })
    }).catch(() => {
      this.setState({processingPayment: false})
      return;
    })
  }

	render() {
		const {
      show,
      proceed,
      dismiss,
      cancel,
    } = this.props;
    const { selectedTab, processingPayment, selectedPlanInfo } = this.state;
		const currentLocale = localStorage.getItem('language')

		return (
			<Modal
				className='payment-modal'

				hasHeader={true}
				hasFooter={true}
				headerTitle={__("Subscribe to {name}", "settings", {name: __(selectedPlanInfo.name, 'settings')})}
				headerIcon="fa icon-credit-card"
        fixedWidth={500}
        onCloseModalClick={dismiss}

        footerType="grey"
				footerButtons={[
					{
						title: __("Pay", "checkoutform"),
						className: "btn btn-primary pull-right pay-btn",
						isDisabled: ()=>{return processingPayment},
						onClick: this.onSubmit,
					}
        ]}
        loading={processingPayment}
				isShowingModal={show}
			>
        <div className='payment-wrapper'>
          <div className='tabs'>
            <div className={`tab ${selectedTab==='monthly'?'selected': ''}`} onClick={this.onTabChange}>{__('Monthly', 'settings')}</div>
            <div className={`tab ${selectedTab==='yearly'?'selected': ''}`} onClick={this.onTabChange}>{__('Yearly', 'settings')}</div>
          </div>
          <div className='payment-info'>
            <div>
              <div>{__('Per Month', 'settings')}</div>
              <div className='info-text'>${selectedPlanInfo.price}<span className='dollar'>{__('USD', 'settings')}</span></div>
            </div>
            <div>
              <div>{__("Today's total", 'settings')}</div>
              <div className='info-text'>
                ${selectedTab ==='monthly'? selectedPlanInfo.price: selectedPlanInfo.price*12}
                <span className='dollar'>{__('USD', 'settings')}</span></div>
            </div>
            <div>
              <div>{__("Next billing date", 'settings')}</div>
              <div className='info-text'>{selectedTab ==='monthly'? moment().add(1, 'M').format('YYYY-MM-DD'): moment().add(1, 'Y').format('YYYY-MM-DD')}</div>
            </div>
          </div>
          <div className='email-section'>
            <div>{__('Email Address', 'checkoutform', null, true)}</div>
            <input placeholder='name@mail.com' className={this.state.class} type='email' value={this.state.email} onChange={this.onChangeEmail} />
          </div>
          <div className='card-section'>
            <div>{__('Credit Card', 'checkoutform', null, true)}</div>
            <CardElement className='stripe-cardnumber' style={cardElementStyle} />
          </div>
          <div className='secure-msg'>{__('Note: 5% tax will be applied on every transaction', locale)}</div>
					<div className='secure-msg'>
						{__('All payments are processed through Stripe. The connection is secure and encrypted. We do not collect any of your information.', locale)}
						<a target='__blank' href={`/privacy-${currentLocale.toLowerCase()}`}>{__('Privacy Policy', locale)}</a>
					</div>
        </div>
			</Modal>
    );
  }
}

export default injectStripe(CheckoutModal);



// WEBPACK FOOTER //
// ./src/template/Modals/SubscriptionPayment/PaymentModal.js